import React from 'react';

// Imagine responsive din public/assets/v2: <name>-<width>.webp / .jpg
const Picture = ({ name, widths, sizes, alt, className, eager = false, width, height }) => {
    const base = "assets/v2/" + name;
    const srcset = (ext) => widths.map((w) => `${base}-${w}.${ext} ${w}w`).join(", ");
    return (
        <picture>
            <source type="image/webp" srcSet={srcset("webp")} sizes={sizes} />
            <img
                className={className}
                src={`${base}-${widths[widths.length - 1]}.jpg`}
                srcSet={srcset("jpg")}
                sizes={sizes}
                alt={alt}
                width={width}
                height={height}
                loading={eager ? "eager" : "lazy"}
                decoding="async"
                fetchpriority={eager ? "high" : undefined}
            />
        </picture>
    );
};

export default Picture;
